import React from "react";
import PopAnimation from "./PopAnimation";

const PopAnimationContainer = ({ pop, popPosition }) => {
  if (!pop) return null;

  return (
    <div
      style={{
        position: "fixed",
        zIndex: 1000,
        borderRadius: "50%",
        width: "600px",
        height: "600px",
        top: `${popPosition.y}px`,
        left: `${popPosition.x}px`,
      }}
    >
      <PopAnimation loggedIn={true} popColor={popPosition.color} />
    </div>
  );
};

export default PopAnimationContainer;
